export default __webpack_public_path__ + "7276dd6.png";